import * as React from "react";
import { MobileTopbar } from "@/components/vroom/mobile-topbar";
import { BottomNav } from "@/components/vroom/bottom-nav";
import { ProfileDialog } from "@/components/profile-dialog/profile-dialog";
import { useProfileUrl } from "@/hooks/use-profile-url";
import type { RoleKind } from "@/components/vroom/role-pill";

export interface MobileAdminShellUser {
  firstName: string;
  lastName: string;
  email?: string;
  erpId?: string;
  role: RoleKind;
}

export interface MobileAdminShellProps {
  user: MobileAdminShellUser;
  bottomNavItems: React.ReactNode;
  onSignOut?: () => void | Promise<void>;
  children: React.ReactNode;
}

export function MobileAdminShell({
  user,
  bottomNavItems,
  onSignOut,
  children,
}: MobileAdminShellProps) {
  const { profileSection, profileOpen, setProfile } = useProfileUrl();
  const canOpenProfile = !!onSignOut && !!user.email;

  return (
    <div className="flex min-h-dvh flex-col bg-surface text-ink-900">
      <MobileTopbar
        variant="admin"
        user={user}
        onAvatarClick={canOpenProfile ? () => setProfile("account") : undefined}
      />
      <main className="flex-1 pb-20">{children}</main>
      <BottomNav variant="admin">{bottomNavItems}</BottomNav>
      {canOpenProfile ? (
        <ProfileDialog
          open={profileOpen}
          onOpenChange={(open) => setProfile(open ? (profileSection ?? "account") : undefined)}
          activeSection={profileSection ?? "account"}
          onSectionChange={(section) => setProfile(section, true)}
          user={{
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email!,
            erpId: user.erpId,
            role: user.role,
          }}
          onSignOut={async () => {
            setProfile(undefined, true);
            await onSignOut!();
          }}
        />
      ) : null}
    </div>
  );
}
